// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertComposeActions } from "src/actions";

import { TabId } from "@blueprintjs/core";

import { Route, Switch } from "react-router-dom";

import { IMainProps, Main } from "./main";

import { IncidentLocation, IncidentLocationProps } from "./incident-location";

import "./styles.css";

interface IAlertDetailsProps extends IMainProps, IncidentLocationProps {
  voice?: any
  routeProps?: any;
  incidentLocation: any;
  expiration: any;
  senderName: any;
  emailFrom: any;
  emailReply: any;
  iPawsDetails: any;
  updateSeverity: (
    type: string,
    id: TabId
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  updateIPaws: (
    type: string,
    value: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  boxClicked: (
    id: string,
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  updateIncidentLocation: (
    status: boolean,
    path: string,
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  updateRadio: (
    type: string,
    value: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  updateDetails: (
    type: string,
    value: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onClearMap: (id: string) => (dispatch: Dispatch<any>) => Promise<void>;
  toggleMoreInfo: (
    type: string,
    screen: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  markerComplete: (marker: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onCopyData: (id: string) => (dispatch: Dispatch<any>) => Promise<void>;
}

interface IAlertDetailsState {
  tabs: Array<string>;
}

class AlertDetails extends React.Component<
  IAlertDetailsProps,
  IAlertDetailsState
> {
  public constructor(props: IAlertDetailsProps) {
    super(props);
    this.onTabChanged = this.onTabChanged.bind(this);
    this.onRadioChanged = this.onRadioChanged.bind(this);
    this.onInputChanged = this.onInputChanged.bind(this);
    this.onIPawsSelectChanged = this.onIPawsSelectChanged.bind(this);
    this.onBoxClick = this.onBoxClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this.onToggleMoreInfo = this.onToggleMoreInfo.bind(this);
    this.onMarkerComplete = this.onMarkerComplete.bind(this);
    this.onClearMap = this.onClearMap.bind(this);
    this.onExpirationSelectChanged = this.onExpirationSelectChanged.bind(this);

    this.state = {
      tabs: ["MINOR", "MODERATE", "SEVERE", "EXTREME"]
    };
  }

  public render() {
    const {
      className,
      severity,
      expiration,
      emailFrom,
      emailReply,
      senderName,
      iPawsDetails,
      incidentLocation,
      voice
    } = this.props;
    const { tabs } = this.state;

    const classes = classNames(className);

    return (
      <Switch>
        <Route
          exact={true}
          path="/alerts/compose/alert-details/"
          render={routeProps => (
            <Main
              callerId={voice.callerId}
              callerName={voice.callerName}
              className={classes}
              tabs={tabs}
              onTabChanged={this.onTabChanged}
              onRadioChanged={this.onRadioChanged}
              onInputChanged={this.onInputChanged}
              onIPawsSelectChanged={this.onIPawsSelectChanged}
              severity={severity}
              onClearMap={this.onClearMap}
              onBoxClick={this.onBoxClick}
              incidentLocation={incidentLocation}
              onExpirationSelectChanged={this.onExpirationSelectChanged}
              expiration={expiration.value}
              senderName={senderName.value}
              emailFrom={emailFrom.value}
              emailReply={emailReply.value}
              iPawsDetails={iPawsDetails}
              onToggleMoreInfo={this.onToggleMoreInfo}
            />
          )}
        />
        <Route
          exact={true}
          path="/alerts/compose/alert-details/incident-location"
          render={routeProps => (
            <IncidentLocation
              onMarkerComplete={this.onMarkerComplete}
              onCancelClick={this.onCancelClick}
              incidentLocation={incidentLocation}
              onSaveClick={this.onSaveClick}
            />
          )}
        />
      </Switch>
    );
  }

  private onClearMap(event: any) {
    this.props.onClearMap("alertDetails");
  }

  private onMarkerComplete(event: any, marker: any) {
    this.props.markerComplete(marker);
  }

  private onBoxClick(event: any) {
    const { history } = this.props.routeProps;
    const id = event.currentTarget.dataset.id;
    this.props.boxClicked(id, history);
  }

  private onCancelClick(event: any) {
    const history = this.props.routeProps.history;
    const status = false;
    const path = "/alerts/compose/alert-details";
    this.props.updateIncidentLocation(status, path, history);
  }

  private onSaveClick(event: any) {
    const history = this.props.routeProps.history;
    const status = true;
    const path = "/alerts/compose/alert-details";
    this.props.updateIncidentLocation(status, path, history);
  }

  private onIPawsSelectChanged(event: any, type: string) {
    const value = event.currentTarget.textContent;
    this.props.updateIPaws(type, value);
  }

  private onExpirationSelectChanged(event: any, type: string) {
    const value = event.currentTarget.textContent;
    this.props.updateDetails(type, value);
  }

  private onInputChanged(event: any, type: string) {
    const value = event.currentTarget.value;
    this.props.updateDetails(type, value);
  }

  private onRadioChanged(event: any, type: string) {
    const value = event.currentTarget.value;
    this.props.updateRadio(type, value);
  }

  private onToggleMoreInfo(event: any, type: string) {
    this.props.toggleMoreInfo(type, "alert-details");
  }

  private onTabChanged(newTabId: TabId, prevTabId: TabId, event: any) {
    this.props.updateSeverity(this.state.tabs[newTabId], newTabId);
  }
}

const mapStateToProps = (state: any) => {
  const { alerts } = state;
  const { composeData } = alerts;
  const { alertDetails } = composeData;
  const {
    voice,
    severity,
    incidentLocation,
    expiration,
    emailFrom,
    emailReply,
    senderName,
    iPawsDetails,
  } = alertDetails;

  return {
    voice,
    iPawsDetails,
    emailFrom,
    emailReply,
    senderName,
    incidentLocation,
    expiration,
    severity,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateSeverity: bindActionCreators(
      alertComposeActions.onAlertDetailsUpdateSeverity,
      dispatch
    ),
    updateIPaws: bindActionCreators(
      alertComposeActions.onAlertDetailsUpdateIPaws,
      dispatch
    ),
    boxClicked: bindActionCreators(
      alertComposeActions.onAlertDetailsBoxClicked,
      dispatch
    ),
    updateRadio: bindActionCreators(
      alertComposeActions.onAlertDetailsUpdateRadio,
      dispatch
    ),
    updateDetails: bindActionCreators(
      alertComposeActions.onAlertDetailsUpdateDetails,
      dispatch
    ),
    updateIncidentLocation: bindActionCreators(
      alertComposeActions.onAlertDetailsUpdateIncidentLocation,
      dispatch
    ),
    onClearMap: bindActionCreators(alertComposeActions.onClearMap, dispatch),
    toggleMoreInfo: bindActionCreators(
      alertComposeActions.onToggleMoreInfo,
      dispatch
    ),
    onCopyData: bindActionCreators(alertComposeActions.onCopyData, dispatch),
    markerComplete: bindActionCreators(
      alertComposeActions.onAlertDetailsMarkerComplete,
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertDetails);



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/alert-details/alert-details.tsx